<template>
  <div class='animated fadeIn'>
  <div v-if='myService.length > 1'>
    <b-form-select v-model="myServiceSelected" :options="myService" class="mb-3" />
  </div>
  <b-row class="d-flex justify-content-end mr-4 mb-2">
    <b-form-checkbox id="checkbox1"
                     v-model="status"
                     value="accepted"
                     unchecked-value="not_accepted">
      非アクティブユーザを表示
    </b-form-checkbox>
  </b-row>
    <b-card>
      <b-row>
        <b-col sm='5'><label for='input-none'>ユーザ</label></b-col>
      </b-row>
      <b-card-body>
        <b-row>
          <b-col>
            <div class='table-responsive'>
              <b-table
                :items='myUsers'
                :fields='fields'
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :current-page='currentPage'
                :per-page='perPage'>
                <div slot='icon' class='avatar' slot-scope='item'>
                  <b-img v-if='item.value' :src='item.value' width='40' height='40'></b-img>
                  <!-- <b-img v-else src='../admin.png' width='40' height='40' class='img-avatar'></b-img> -->
                </div>
                <div slot='service' slot-scope='row'>
                  {{ checkService(row.item) }}
                </div>
                <div slot='group' slot-scope='row'>
                  {{ checkGroup(row.item) }}
                </div>
                <div slot='updatedAt' slot-scope='item'>
                  {{ item.value * 1000 | moment }}
                </div>
                <div slot='createdAt' slot-scope='item'>
                  {{ item.value * 1000 | moment }}
                </div>
                <div slot='key' slot-scope='item'>
                  <p v-if='authUser.role === "admin"' class='small text-muted'>{{ item.value }}</p>
                  <div class='mr-auto align-middle'>
                    <el-button type='success' icon='el-icon-edit' circle v-on:click='editButton(item.value)'></el-button>
                  </div>
                </div>
              </b-table>
            </div>
          <b-pagination align='center' size='sm' :total-rows='myUsers.length' v-model='currentPage' :per-page='perPage'>
          </b-pagination>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  data () {
    return {
      sortBy: 'createdAt',
      sortDesc: false,
      fields: {
        icon: {
          label: '',
          class: 'text-center'
        },
        name: {
          label: '名前',
          class: 'text-center',
          sortable: true
        },
        email: {
          label: 'メール',
          class: 'text-center',
          sortable: true
        },
        status: {
          label: '私のスローガン',
          class: 'text-center'
        },
        service: {
          label: 'サービス',
          class: 'text-center m-0'
        },
        group: {
          label: 'グループ',
          class: 'text-center m-0'
        },
        role: {
          label: '権限',
          class: 'text-center',
          sortable: true
        },
        updatedAt: {
          label: '更新日時',
          class: 'text-center m-0',
          sortable: true
        },
        createdAt: {
          label: '作成日時',
          class: 'text-center m-0',
          sortable: true
        },
        key: {
          label: '',
          class: 'text-center'
        }
      },
      currentPage: 1,
      perPage: 20,
      myService: [],
      myServiceSelected: null,
      unwatch: null,
      unwatch1: null,
      status: 'not_accepted'
    }
  },
  beforeDestroy () {
    if (this.unwatch) {
      this.unwatch()
      this.unwatch = null
    }
    if (this.unwatch1) {
      this.unwatch1()
      this.unwatch1 = null
    }
  },
  created () {
    this.unwatch = this.$store.watch(
      state => this.$store.getters['service/services'],
      value => {
        this.createServiceSelector()
        this.getUsersForSelectedService()
      }
    )
    this.unwatch1 = this.$store.watch(
      state => this.$store.getters['suser/users'],
      value => {
        this.createServiceSelector()
        this.getUsersForSelectedService()
      }
    )
    if (this.services) {
      this.createServiceSelector()
      this.getUsersForSelectedService()
    }
  },
  computed: {
    ...mapGetters({
      services: 'service/services',
      users: 'user/users',
      authUser: 'authUser/user'
    })
  },
  watch: {
    myServiceSelected: function () {
      this.getUsersForSelectedService()
    },
    status: function () {
      this.getUsersForSelectedService()
    }
  },
  methods: {
    getUsersForSelectedService () {
      this.myUsers = []
      if (this.myServiceSelected) {
        for (var index in this.users) {
          var user = this.users[index]
          if (this.status === 'accepted') {
            if (user.services[this.myServiceSelected] === true || user.services[this.myServiceSelected] === false) {
              this.myUsers.push(user)
            }
          } else if (user.services[this.myServiceSelected] === true) {
            this.myUsers.push(user)
          }
        }
      }
    },
    createServiceSelector () {
      this.myServiceSelected = null
      this.myService = []
      if (this.authUser) {
        for (var key in this.authUser.services) {
          if (this.authUser.services[key]) {
            var index = this.services.findIndex(service => service.key === key)
            if (index !== -1) {
              var service = JSON.parse(JSON.stringify(this.services[index]))
              this.myService.push({
                value: service.key,
                text: service.name
              })
            }
          }
        }
      }
      if (this.myService.length !== 0) {
        this.myServiceSelected = this.myService[0].value
      }
    },
    checkService (user) {
      var number = 0
      for (var service in user.services) {
        if (user.services[service]) {
          number += 1
        }
      }
      return number
    },
    checkGroup (user) {
      var number = 0
      for (var group in user.groups) {
        if (user.groups[group]) {
          number += 1
        }
      }
      return number
    },
    editButton (key) {
      this.$store.dispatch('dispatch/setUser', key).then(() => {
        this.$router.push({path: 'users/edit'})
      })
    },
    addButton () {
      this.$store.dispatch('dispatch/setUser', null).then(() => {
        this.$router.push({path: 'users/register'})
      })
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>

<style>
table td {
  vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Users.vue